<template>
  <div class="inputgroupdriver">
    <AutoComplete
      v-if="driverShow"
      :labelText="required ? '*司機' : '司機'"
      placeholder="輸入司機隊編"
      type="search"
      :value="driver"
      :items="driverSearchResult"
      :id="idOfDriver"
      :disabled="disabled"
      :validation="required ? 'reauired' : ''"
      @input="$emit('searchDriverId', $event)"
      @selectDropdownItem="$emit('selectDriverId', $event)"
    />

    <AutoComplete
      v-if="licenseNumberShow"
      :labelText="required ? '*使用車牌' : '使用車牌'"
      placeholder="輸入車牌(英文須大寫、半形字)"
      type="search"
      :value="licenseNumber"
      :items="licenseNumberSearchResult"
      :id="idOfLicenseNumber"
      :disabled="disabled"
      :validation="required ? 'reauired' : ''"
      @input="$emit('searchLicenseNumber', $event)"
      @selectDropdownItem="$emit('selectLicenseNumber', $event)"
    />
  </div>
</template>

<script>
import AutoComplete from '@/components/commen/AutoComplete';

export default {
  name: 'InputGroupDriver',
  components: {
    AutoComplete
  },
  props: {
    idOfDriver: {
      type: String,
      default: 'driverId'
    },
    idOfLicenseNumber: {
      type: String,
      default: 'licenseNumber'
    },
    driver: {
      type: [String, Number, null],
      default: ''
    },
    licenseNumber: {
      type: [String, null],
      default: ''
    },
    driverSearchResult: {
      type: Array,
      required: true
    },
    licenseNumberSearchResult: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    driverShow: {
      type: Boolean,
      default: true
    },
    licenseNumberShow: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.inputgroupdriver {
  .autocomplete {
    padding: 20px 80px;
    &:first-child {
      border-bottom: 1px solid #ededed;
    }
    &:hover {
      background-color: #fafafa;
    }
  }
}

.widerlabel {
  .autocomplete-label {
    flex: 0 0 100px;
  }
}

.small {
  .autocomplete {
    padding: 10px 80px;
  }
}
</style>
